import React from "react";
import { useFormikContext } from "formik";
import PropertyGround from "assets/icons/PropertyGround.svg";
import Plumbing from "assets/icons/Plumbing.svg";
import Electrical from "assets/icons/Electrical.svg";
import SnowFlake from "assets/icons/SnowFlake.svg";
import Appliances from "assets/icons/Appliances.svg";
import DoorsWindows from "assets/icons/DoorsWindows.svg";
import LockedOut from "assets/icons/LockedOut.svg";
import GeneralMaintainance from "assets/icons/GeneralMaintainance.svg";
import Flooring from "assets/icons/Flooring.svg";
import PestControl from "assets/icons/PestControl.svg";
import Exterior from "assets/icons/Exterior.svg";
import Roofing from "assets/icons/Roofing.svg";
import Cleaning from "assets/icons/Cleaning.svg";
import Painting from "assets/icons/Painting.svg";

const Step4 = () => {
  const { values, setFieldValue, errors, touched } = useFormikContext();
  const cards = [
    {
      label: "Property Grounds",
      icon: PropertyGround,
      value: "PROPERTY_GROUNDS",
    },
    { label: "Plumbing", icon: Plumbing, value: "PLUMBING" },
    { label: "Electrical", icon: Electrical, value: "ELECTRICAL" },
    { label: "HVAC", icon: SnowFlake, value: "HVAC" },
    { label: "Appliances", icon: Appliances, value: "APPLIANCES" },
    { label: "Window & Door", icon: DoorsWindows, value: "DOORS_WINDOWS" },
    { label: "Locksmith", icon: LockedOut, value: "LOCKSMITH" },
    {
      label: "General Maintenance",
      icon: GeneralMaintainance,
      value: "GENERAL_MAINTENANCE",
    },
    { label: "Flooring", icon: Flooring, value: "FLOORING" },
    { label: "Painting", icon: Painting, value: "PAINTING" },
    { label: "Pest Control", icon: PestControl, value: "PEST_CONTROL" },
    { label: "Exterior", icon: Exterior, value: "EXTERIOR" },
    { label: "Roofing", icon: Roofing, value: "ROOFING" },
    { label: "Cleaning", icon: Cleaning, value: "CLEANING" },
  ];
  return (
    <div className=" flex flex-col  gap-8  w-full  ">
      {/* Error message display */}
      {errors.issue_type && touched.issue_type && (
        <div className="w-full text-center">
          <p className="text-red-500 text-sm font-medium">
            {errors.issue_type}
          </p>
        </div>
      )}

      <div className="flex flex-wrap gap-5 items-center justify-center  ">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`flex flex-col items-center max-w-[188px] w-full justify-center md:p-5 p-2 border rounded-[16px] hover:bg-gray-50 cursor-pointer transition-all duration-300 ${
              values.issue_type === card.value
                ? "border-[#0066FF] bg-[#F0F7FF]"
                : "border-[#ECECEC]"
            }`}
            onClick={() => {
              setFieldValue("issue_type", card.value);
              // Reset sub_issue_type when issue_type changes
              setFieldValue("sub_issue_type", "");
            }}
          >
            <img src={card.icon} alt={card.label} className="w-8 h-8 mb-4" />
            <span className="text-center font-medium text-[#242424]">
              {card.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step4;
